import { Accordion, AccordionDetails, AccordionSummary, AppBar, Box, Button, debounce, Dialog, Divider, Grid, List, ListItem, ListItemButton, ListItemText, TextField, Toolbar, Typography } from "@mui/material"
import { useOcupacaoService } from "../../../../../../../use-cases/geo-veles/ocupacao"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { Transition } from "../../../../../../components"
import { theme } from "../../../../../../styles"
// Icons
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ProfissaoFilterPreview } from "./profissao-filter-preview"
import { useEffect } from "react"
import { useProjetosService } from "../../../../../../../use-cases/geo-veles"

export const DialogFiltroProfissao = () => {
    // State
    const { ocupacoes, openOcupacaoDialog, searchTerm } = useAppSelector((state) => state.ocupacao)
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
    // Hook
    const { addProfissaoFilter } = useProjetosService()
    const {
        setOpenOcupacaoDialog,
        resetCategoria,
        resetOcupacoes,
        resetSearchTerm,
        setSearchTerm,
        searchOcupacoes
    } = useOcupacaoService()

    useEffect(() => {
        if (searchTerm.length > 0) {
            searchOcupacoes()
        }
    }, [searchOcupacoes, searchTerm])

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={openOcupacaoDialog}
            onClose={() => {
                setOpenOcupacaoDialog(false)
                resetCategoria()
                resetOcupacoes()
                resetSearchTerm()
            }}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" textTransform="uppercase">
                        Selecionar Profissão
                    </Typography>
                    <Button
                        autoFocus
                        color="inherit"
                        onClick={() => {
                            setOpenOcupacaoDialog(false)
                            resetCategoria()
                            resetOcupacoes()
                            resetSearchTerm()
                        }}
                    >
                        Fechar
                    </Button>
                </Toolbar>
            </AppBar>
            <Box p={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Digite o código ou descrição do profissão"
                            placeholder="Digite o código ou descrição do profissão"
                            onChange={debounce((e) => setSearchTerm(e.target.value), 500)}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Grid container>
                <Grid item xs={6}>
                    <List >
                        {
                            ocupacoes.filter((ocupacao) => {
                                if (filtrosSelecionados?.profissao?.find((profissao) => profissao.familiacodigo === ocupacao.familiacodigo)) {
                                    return false
                                } else {
                                    return true
                                }
                            }).map((ocupacao, index) => {
                                return (<>
                                    <div key={index}>
                                        <ListItem
                                            style={{
                                                padding: 0
                                            }}
                                        >
                                            <ListItemButton
                                                onClick={(e) => {
                                                    addProfissaoFilter(ocupacao)
                                                }}
                                            >
                                                <ListItemText primary={ocupacao.familiadescricao ? ocupacao.familiadescricao.toUpperCase() : ''} />
                                                <Box>
                                                    <PersonOutlineIcon />
                                                </Box>
                                            </ ListItemButton>
                                        </ListItem>
                                        <Divider color={theme.palette.primary.main} />
                                    </div>
                                </>)
                            })
                        }
                    </List>
                </Grid>
                {
                    (filtrosSelecionados?.profissao?.length ?? 0) > 0 &&
                    <Grid xs={6}>
                        <Box p={3} my={3}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography variant="h5" color="primary" fontWeight="bold" textTransform="uppercase">
                                        Profissões selecionadas
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ProfissaoFilterPreview />
                                </AccordionDetails>
                            </Accordion>
                        </Box>
                    </Grid>
                }
            </Grid>
        </Dialog>
    )
}